import { DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI } from '../../../types/default-cloud-graph-remote-link-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { WebexIcon, WebexIconBorderless, WebexSearchResultIcon } from './icon';

export const webexConfig: ThirdPartyConfig = {
	displayName: 'Webex',
	id: 'webex',
	resourceType: ProductResourceTypes3P.Webex,
	icon: get3PLogo(WebexIcon, 'Webex', 'medium'),
	iconBorderless: get3PLogo(WebexIconBorderless, 'Webex', 'small'),
	searchResultIcon: get3PLogo(WebexSearchResultIcon, 'Webex', 'large'),
	integrationAri: 'ari:cloud:platform::integration/cisco',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_REMOTE_LINK_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Video],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
